import { useEffect, useState } from 'react';
import { ArrowRight, UploadCloud, Activity, Handshake, Twitter, Instagram, Linkedin, Sparkles } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

const Index = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isAuthenticated, user } = useAuthStore();
  const navigate = useNavigate();

  // Helper function to determine dashboard route
  const getDashboardRoute = () => {
    console.log('🔍 getDashboardRoute called');
    console.log('🔍 user object:', user);
    console.log('🔍 user role:', user?.role);
    console.log('🔍 isAuthenticated:', isAuthenticated);
    console.log('🔍 is brand user check:', user?.role === 'brand_user');
    
    // Check for brand user role
    if (user?.role === 'brand_user') {
      console.log('✅ Returning /brand-dashboard');
      return '/brand-dashboard';
    }
    
    console.log('❌ Returning /dashboard');
    return '/dashboard';
  };

  useEffect(() => {
    // Load Unicorn Studio script
    const script = document.createElement('script');
    script.src = "https://cdn.jsdelivr.net/gh/hiunicornstudio/unicornstudio.js@v1.4.29/dist/unicornStudio.umd.js";
    script.onload = () => {
      // @ts-ignore
      if (window.UnicornStudio && !window.UnicornStudio.isInitialized) {
        // @ts-ignore
        window.UnicornStudio.init();
        // @ts-ignore
        window.UnicornStudio.isInitialized = true;
      }
    };
    document.body.appendChild(script);

    return () => {
      // Cleanup if necessary, though this script modifies DOM significantly so simpler to leave it or handle carefully
      // For now we just append it.
    };
  }, []);

  return (
    <div className="antialiased bg-white text-neutral-900 font-geist relative isolate">
      
      {/* Background (component) */}
      <div className="aura-background-component top-0 w-full -z-10 absolute h-[1000px] hue-rotate-[160deg] saturate-[2.5] brightness-125">
        <div data-us-project="ty3N7ZPaIU7KlWixQFIc" className="absolute top-0 left-0 -z-10 w-full h-full"></div>
      </div>

      {/* Navigation (Sticky) */}
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-neutral-100 transition-all duration-300">
        <div className="lg:px-8 max-w-7xl mr-auto ml-auto pr-6 pl-6">
          <div className="flex h-20 items-center justify-between">
            {/* Brand */}
            <Link to="/" className="flex items-center gap-2 group">
              <div className="w-8 h-8 bg-neutral-900 rounded-lg flex items-center justify-center text-white font-bold font-geist text-xl group-hover:bg-neutral-800 transition-colors">
                A
              </div>
              <span className="text-xl font-bold tracking-tight text-neutral-900 font-geist">
                Artie
              </span>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-8 text-sm text-neutral-600 font-medium">
              <a href="#how-it-works" className="hover:text-neutral-900 transition-colors font-geist">How it Works</a>
              <a href="#creators" className="hover:text-neutral-900 transition-colors font-geist">For Creators</a>
              <div className="flex items-center gap-2 cursor-not-allowed opacity-60 select-none">
                <span className="font-geist">For Buyers</span>
                <span className="px-1.5 py-0.5 text-[10px] font-medium bg-neutral-100 text-neutral-500 rounded-full border border-neutral-200">Coming Soon</span>
              </div>

            </nav>

            {/* Desktop Actions */}
            <div className="hidden md:flex items-center gap-4">
              {isAuthenticated && user ? (
                <>
                  <button
                    onClick={() => {
                      const route = getDashboardRoute();
                      navigate(route);
                    }}
                    className="text-sm font-medium text-neutral-600 hover:text-neutral-900 transition-colors font-geist"
                  >
                    Dashboard
                  </button>
                  <Link to="/projects/new" className="inline-flex items-center justify-center h-10 px-5 text-sm font-medium text-white transition-colors bg-neutral-900 rounded-full hover:bg-neutral-800 font-geist shadow-md hover:shadow-lg">New Project</Link>
                </>
              ) : (
                <>
                  <Link to="/login" className="text-sm font-medium text-neutral-600 hover:text-neutral-900 transition-colors font-geist">Log In</Link>
                  <Link to="/signup" className="inline-flex items-center justify-center h-10 px-5 text-sm font-medium text-white transition-colors bg-neutral-900 rounded-full hover:bg-neutral-800 font-geist shadow-md hover:shadow-lg">Get Started</Link>
                </>
              )}
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden inline-flex hover:bg-neutral-100 transition-colors bg-neutral-50 w-10 h-10 rounded-full items-center justify-center ring-1 ring-black/5" 
              aria-label="Toggle menu" 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {!isMobileMenuOpen ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-neutral-900">
                  <path d="M3 12h18"></path>
                  <path d="M3 6h18"></path>
                  <path d="M3 18h18"></path>
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-neutral-900">
                  <path d="M18 6 6 18"></path>
                  <path d="M6 6l12 12"></path>
                </svg>
              )}
            </button>
          </div>

          {/* Mobile Navigation Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-neutral-100 shadow-xl z-50">
              <nav className="p-6 space-y-4">
                <a href="#how-it-works" className="block text-base font-medium text-neutral-600 hover:text-neutral-900 font-geist py-2" onClick={() => setIsMobileMenuOpen(false)}>How it Works</a>
                <a href="#creators" className="block text-base font-medium text-neutral-600 hover:text-neutral-900 font-geist py-2" onClick={() => setIsMobileMenuOpen(false)}>For Creators</a>
                <a href="#buyers" className="block text-base font-medium text-neutral-600 hover:text-neutral-900 font-geist py-2" onClick={() => setIsMobileMenuOpen(false)}>For Buyers</a>
                <div className="pt-4 border-t border-neutral-100 flex flex-col gap-3">
                  {isAuthenticated && user ? (
                    <>
                      <button
                        onClick={() => {
                          const route = getDashboardRoute();
                          navigate(route);
                        }}
                        className="block text-center text-base font-medium text-neutral-600 hover:text-neutral-900 font-geist py-2 w-full"
                      >
                        Dashboard
                      </button>
                      <Link to="/projects/new" className="flex items-center justify-center w-full h-12 text-base font-medium text-white bg-neutral-900 rounded-full shadow-md font-geist">New Project</Link>
                    </>
                  ) : (
                    <>
                      <Link to="/login" className="block text-center text-base font-medium text-neutral-600 hover:text-neutral-900 font-geist py-2">Log In</Link>
                      <Link to="/signup" className="flex items-center justify-center w-full h-12 text-base font-medium text-white bg-neutral-900 rounded-full shadow-md font-geist">Get Started</Link>
                    </>
                  )}
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>

      <main className="">
        {/* Hero Section */}
        <section className="sm:px-8 max-w-7xl mr-auto ml-auto pr-6 pb-16 pl-6 pt-10 lg:pt-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 items-center">
            {/* Left: Copy */}
            <div className="max-w-xl relative z-10">
              {/* Social proof pill */}
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange-50 border border-orange-100 mb-8 transition-all duration-700 ease-out">
                <span className="flex h-2 w-2 rounded-full bg-orange-500 animate-pulse"></span>
                <span className="text-xs font-medium text-orange-600 font-geist uppercase tracking-wide">For Creators & Storytellers</span>
              </div>

              {/* Headline */}
              <h1 className="sm:text-5xl lg:text-[64px] leading-[1.05] transition-all duration-700 ease-out delay-150 text-4xl font-semibold text-neutral-900 tracking-tighter font-geist mb-6">
                Know what your project is worth.
              </h1>

              <p className="text-lg sm:text-xl leading-relaxed text-neutral-600 font-geist mb-8 transition-all duration-700 ease-out delay-300 max-w-md">
                Upload your script. Get your Artie Score. Connect with producers and brands who are looking for stories just like yours.
              </p>

              {/* CTAs */}
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-12 transition-all duration-700 ease-out delay-[450ms]">
                {isAuthenticated && user ? (
                  <>
                    <Link to="/projects/new" className="group inline-flex items-center justify-center hover:bg-neutral-800 transition-colors font-medium text-white bg-neutral-900 rounded-full h-12 px-8 shadow-lg hover:shadow-xl w-full sm:w-auto">
                      <span className="font-geist">Create New Project</span>
                      <ArrowRight className="h-4 w-4 ml-2" />
                    </Link>
                    <button
                      onClick={() => {
                        alert('Button clicked! User role: ' + (user?.role || 'undefined'));
                        const route = getDashboardRoute();
                        navigate(route);
                      }}
                      className="inline-flex items-center justify-center gap-2 text-neutral-600 font-medium hover:text-neutral-900 transition-colors font-geist h-12 px-6 rounded-full border border-neutral-200 hover:bg-neutral-50 w-full sm:w-auto"
                    >
                      Go to Dashboard
                    </button>
                  </>
                ) : (
                  <>
                    <Link to="/signup" className="group inline-flex items-center justify-center hover:bg-neutral-800 transition-colors font-medium text-white bg-neutral-900 rounded-full h-12 px-8 shadow-lg hover:shadow-xl w-full sm:w-auto">
                      <span className="font-geist">Get Your Score — Free</span>
                      <ArrowRight className="h-4 w-4 ml-2" />
                    </Link>
                    <a href="#how-it-works" className="inline-flex items-center justify-center gap-2 text-neutral-600 font-medium hover:text-neutral-900 transition-colors font-geist h-12 px-6 rounded-full border border-neutral-200 hover:bg-neutral-50 w-full sm:w-auto">
                      See How It Works
                    </a>
                  </>
                )}
              </div>

              {/* Partners */}
              <div className="transition-all duration-700 ease-out delay-[600ms]">
                <p className="text-sm text-neutral-400 font-geist mb-4 font-medium">TRUSTED BY PARTNERS AT</p>
                <div className="flex gap-6 items-center opacity-60 grayscale hover:grayscale-0 transition-all duration-500">
                  <span className="text-xl font-bold font-playfair text-neutral-800">CAA</span>
                  <span className="text-xl font-bold font-geist tracking-tighter text-neutral-800">A24</span>
                  <span className="text-xl font-bold font-geist text-neutral-800">NETFLIX</span>
                  <span className="text-xl font-bold font-playfair italic text-neutral-800">Hulu</span>
                </div>
              </div>
            </div>

            {/* Right: Abstract/Dashboard Visual */}
            <div className="relative lg:h-[700px] h-[500px] w-full flex items-center justify-center select-none">
              <div className="relative w-full h-full flex items-center justify-center">
                
                {/* Floating Component: Market Analysis (Top Right) */}
                <div className="absolute top-0 right-0 sm:top-12 sm:right-6 z-10 hidden sm:block">
                  <div className="bg-white/90 backdrop-blur-md p-4 rounded-2xl shadow-xl border border-white/40 transform rotate-6 hover:rotate-0 transition-all duration-500 hover:scale-105 cursor-default w-40">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-1.5 h-1.5 rounded-full bg-orange-500 animate-pulse"></div>
                      <span className="text-[10px] font-semibold text-neutral-500 uppercase font-geist tracking-wide">Market Demand</span>
                    </div>
                    <div className="flex items-end gap-1.5 h-10 w-full">
                      <div className="w-full bg-orange-100 h-[30%] rounded-t-sm transition-all hover:bg-orange-200"></div>
                      <div className="w-full bg-orange-200 h-[50%] rounded-t-sm transition-all hover:bg-orange-300"></div>
                      <div className="w-full bg-orange-300 h-[40%] rounded-t-sm transition-all hover:bg-orange-400"></div>
                      <div className="w-full bg-orange-400 h-[80%] rounded-t-sm transition-all hover:bg-orange-500"></div>
                      <div className="w-full bg-orange-500 h-[65%] rounded-t-sm transition-all hover:bg-orange-600"></div>
                    </div>
                    <div className="mt-2 text-right">
                      <span className="text-xs font-semibold text-neutral-900 font-geist">+24% YoY</span>
                    </div>
                  </div>
                </div>

                {/* Floating Component: Genre Tags (Bottom Left) */}
                <div className="absolute bottom-16 left-8 z-10 hidden sm:block">
                  <div className="bg-white/90 backdrop-blur-md p-3 rounded-xl shadow-xl border border-white/40 transform -rotate-3 hover:rotate-0 transition-all duration-500 hover:scale-105 cursor-default group">
                    <div className="flex flex-col gap-2">
                      <div className="flex items-center gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-orange-400 group-hover:bg-orange-500 transition-colors"></span>
                        <span className="text-[10px] font-semibold text-neutral-500 uppercase font-geist">Genre Fit</span>
                      </div>
                      <div className="flex gap-1.5">
                        <span className="px-2 py-1 bg-neutral-50 text-neutral-700 text-[10px] font-semibold rounded-md font-geist border border-neutral-200">Sci-Fi</span>
                        <span className="px-2 py-1 bg-neutral-50 text-neutral-700 text-[10px] font-semibold rounded-md font-geist border border-neutral-200">Indie</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Floating Component: Match Alert (Top Left) */}
                <div className="absolute top-24 left-0 sm:left-10 z-30 hidden sm:flex items-center gap-2.5 bg-neutral-900/95 backdrop-blur text-white px-4 py-2 rounded-full shadow-xl transform -rotate-6 hover:rotate-0 transition-all duration-300 cursor-pointer hover:bg-neutral-800 border border-white/10 ring-1 ring-black/5">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                  </span>
                  <span className="text-[10px] font-semibold font-geist tracking-wide">3 PRODUCERS VIEWING</span>
                </div>

                {/* Mockup: Script Card (Behind Left) */}
                <div className="absolute z-10 top-20 left-4 sm:left-10 bg-white/70 backdrop-blur-sm rounded-2xl shadow-lg border border-white/50 p-5 w-64 transform rotate-[-8deg] transition-all duration-700 hover:rotate-[-4deg] hover:translate-x-2 hover:bg-white/95">
                  <div className="flex items-center gap-2.5 mb-4">
                    <div className="w-8 h-8 bg-red-50 rounded-lg flex items-center justify-center text-red-400 border border-red-100">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                      </svg>
                    </div>
                    <div className="h-2 w-24 bg-neutral-200/50 rounded-full"></div>
                  </div>
                  <div className="space-y-2.5 opacity-60">
                    <div className="h-1.5 w-full bg-neutral-300/50 rounded-full"></div>
                    <div className="h-1.5 w-5/6 bg-neutral-300/50 rounded-full"></div>
                    <div className="h-1.5 w-4/5 bg-neutral-300/50 rounded-full"></div>
                    <div className="h-1.5 w-full bg-neutral-300/50 rounded-full"></div>
                  </div>
                </div>

                {/* Mockup: Main Score Card (Center) */}
                <div className="relative z-20 bg-white rounded-2xl shadow-[0_25px_50px_-12px_rgba(0,0,0,0.15)] border border-neutral-100 p-7 w-full max-w-sm transform rotate-[-2deg] transition-all duration-500 hover:rotate-0 hover:scale-[1.02] hover:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.2)] group">
                  {/* Header */}
                  <div className="flex justify-between items-center mb-6">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 rounded-full bg-gradient-to-br from-orange-50 to-amber-50 flex items-center justify-center text-orange-600 shadow-sm ring-1 ring-orange-100/50">
                        <Sparkles className="w-[22px] h-[22px]" />
                      </div>
                      <div>
                        <p className="text-[10px] text-neutral-500 font-geist font-semibold uppercase tracking-wider mb-0.5">Artie Score</p>
                        <p className="text-neutral-900 font-semibold font-geist text-lg leading-tight">The Mars Project</p>
                      </div>
                    </div>
                    <span className="px-2.5 py-1 bg-green-50 text-green-700 text-[10px] font-semibold rounded-full font-geist border border-green-100">TOP 5%</span>
                  </div>

                  {/* Score Display */}
                  <div className="flex items-baseline gap-2 mb-2 justify-center py-2 relative">
                    <span className="text-7xl font-semibold text-neutral-900 font-geist tracking-tighter drop-shadow-sm">92</span>
                    <span className="text-xl text-neutral-400 font-geist font-medium">/ 100</span>
                    {/* Floating Star */}
                    <div className="absolute -right-2 top-2 text-orange-400 animate-pulse hidden sm:block">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                      </svg>
                    </div>
                  </div>

                  {/* Progress Bar */}
                  <div className="w-full bg-neutral-100 h-3 rounded-full overflow-hidden mb-6 shadow-inner ring-1 ring-neutral-100">
                    <div className="bg-gradient-to-r from-orange-500 via-red-500 to-amber-500 h-full rounded-full relative overflow-hidden group-hover:brightness-110 transition-all duration-300" style={{ width: '92%' }}>
                      <div className="absolute top-0 left-0 bottom-0 right-0 bg-gradient-to-r from-transparent via-white/20 to-transparent w-full -translate-x-full group-hover:animate-[spin_2s_linear_infinite] opacity-50"></div>
                    </div>
                  </div>

                  {/* Details */}
                  <div className="grid grid-cols-2 gap-4 pt-5 border-t border-neutral-100">
                    <div className="group/item cursor-default">
                      <p className="text-[10px] text-neutral-400 font-geist uppercase tracking-wide mb-1.5 font-medium group-hover/item:text-neutral-600 transition-colors">Commercial</p>
                      <div className="flex items-center gap-1.5">
                        <div className="w-1.5 h-1.5 rounded-full bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.4)]"></div>
                        <span className="text-sm font-medium text-neutral-900 font-geist">Very High</span>
                      </div>
                    </div>
                    <div className="pl-6 border-l border-neutral-100 group/item cursor-default">
                      <p className="text-[10px] text-neutral-400 font-geist uppercase tracking-wide mb-1.5 font-medium group-hover/item:text-neutral-600 transition-colors">Originality</p>
                      <div className="flex items-center gap-1.5">
                        <div className="w-1.5 h-1.5 rounded-full bg-orange-500 shadow-[0_0_8px_rgba(249,115,22,0.4)]"></div>
                        <span className="text-sm font-medium text-neutral-900 font-geist">Strong</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mockup: Brand Match (Behind Right) */}
                <div className="absolute z-10 bottom-24 right-4 sm:right-10 bg-white/90 backdrop-blur-md rounded-2xl shadow-xl border border-white/50 p-5 w-60 transform rotate-[6deg] transition-all duration-700 hover:rotate-[3deg] hover:-translate-y-2 hover:bg-white hover:z-30 hover:shadow-2xl">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-xl bg-black flex items-center justify-center text-white font-bold text-xs shadow-md">A24</div>
                    <div>
                      <p className="text-xs font-semibold text-neutral-900 font-geist">Production Co.</p>
                      <p className="text-[10px] text-green-600 font-geist font-semibold flex items-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        98% Match
                      </p>
                    </div>
                  </div>
                  <button className="w-full py-2 bg-neutral-900 text-white text-xs rounded-lg font-medium font-geist shadow-md hover:bg-neutral-800 transition-colors flex items-center justify-center gap-2 group/btn">
                    Connect
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="transition-transform group-hover/btn:translate-x-0.5">
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="py-24 bg-white relative" id="how-it-works">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-neutral-900 font-geist mb-4">
                Three steps to unlock your project's potential
              </h2>
              <p className="text-lg text-neutral-600 font-geist">
                From rough draft to deal-ready. We guide you through the process.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Step 1 */}
              <div className="bg-neutral-50 rounded-[24px] p-8 border border-neutral-100 hover:shadow-lg transition-all duration-300 group">
                <div className="w-12 h-12 bg-white rounded-xl shadow-sm border border-neutral-100 flex items-center justify-center mb-6 text-neutral-900 group-hover:scale-110 transition-transform">
                  <UploadCloud className="h-6 w-6" />
                </div>
                <div className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-neutral-200 text-neutral-600 text-sm font-bold mb-4 font-geist">1</div>
                <h3 className="text-xl font-semibold text-neutral-900 font-geist mb-3">Upload</h3>
                <p className="text-neutral-600 leading-relaxed font-geist">
                  Share your script, pitch deck, or detailed outline securely on our platform.
                </p>
              </div>

              {/* Step 2 */}
              <div className="bg-neutral-50 rounded-[24px] p-8 border border-neutral-100 hover:shadow-lg transition-all duration-300 group">
                <div className="w-12 h-12 bg-white rounded-xl shadow-sm border border-neutral-100 flex items-center justify-center mb-6 text-orange-600 group-hover:scale-110 transition-transform">
                  <Activity className="h-6 w-6" />
                </div>
                <div className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 text-orange-700 text-sm font-bold mb-4 font-geist">2</div>
                <h3 className="text-xl font-semibold text-neutral-900 font-geist mb-3">Score</h3>
                <p className="text-neutral-600 leading-relaxed font-geist">
                  Get your multi-dimensional Artie Score based on market trends and narrative strength.
                </p>
              </div>

              {/* Step 3 */}
              <div className="bg-neutral-50 rounded-[24px] p-8 border border-neutral-100 hover:shadow-lg transition-all duration-300 group">
                <div className="w-12 h-12 bg-white rounded-xl shadow-sm border border-neutral-100 flex items-center justify-center mb-6 text-green-600 group-hover:scale-110 transition-transform">
                  <Handshake className="h-6 w-6" />
                </div>
                <div className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-green-100 text-green-700 text-sm font-bold mb-4 font-geist">3</div>
                <h3 className="text-xl font-semibold text-neutral-900 font-geist mb-3">Connect</h3>
                <p className="text-neutral-600 leading-relaxed font-geist">
                  Match with vetted producers and brands looking for content exactly like yours.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section (What You Get) */}
        <section className="py-20 bg-neutral-950 text-white rounded-[40px] mx-4 lg:mx-8 shadow-2xl overflow-hidden relative" id="creators">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
            <div className="absolute top-20 right-20 w-96 h-96 bg-orange-600 rounded-full blur-[100px]"></div>
            <div className="absolute bottom-20 left-20 w-80 h-80 bg-red-600 rounded-full blur-[100px]"></div>
          </div>

          <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
            <div className="mb-16">
              <span className="text-orange-400 font-semibold tracking-wide uppercase text-sm font-geist">Features</span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold mt-3 font-geist">
                Everything you need to pitch with confidence.
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
              {/* Feature 1: Artie Score */}
              <div className="bg-white/5 border border-white/10 rounded-[28px] p-8 backdrop-blur-sm hover:bg-white/10 transition-colors">
                <div className="h-48 rounded-xl bg-gradient-to-br from-neutral-800 to-neutral-900 border border-white/10 mb-6 flex items-center justify-center relative overflow-hidden group">
                  {/* Abstract viz */}
                  <div className="w-32 h-32 rounded-full border-[6px] border-white/20 flex items-center justify-center relative">
                    <div className="absolute inset-0 rounded-full border-[6px] border-orange-500 border-t-transparent rotate-45"></div>
                    <span className="text-4xl font-bold font-geist">92</span>
                  </div>
                </div>
                <h3 className="text-2xl font-semibold mb-2 font-geist">Know your worth</h3>
                <p className="text-neutral-400 font-geist">
                  Get a comprehensive valuation of your project based on genre, budget, and market demand.
                </p>
              </div>

              {/* Feature 2: Pitch Deck */}
              <div className="bg-white/5 border border-white/10 rounded-[28px] p-8 backdrop-blur-sm hover:bg-white/10 transition-colors">
                <div className="h-48 rounded-xl bg-gradient-to-br from-neutral-800 to-neutral-900 border border-white/10 mb-6 flex items-center justify-center relative overflow-hidden">
                  <div className="w-3/4 h-3/4 bg-white/5 rounded-lg border border-white/10 p-4 transform rotate-3 transition-transform hover:rotate-0">
                    <div className="h-2 w-1/3 bg-white/20 rounded mb-3"></div>
                    <div className="h-24 bg-white/5 rounded mb-3"></div>
                    <div className="flex gap-2">
                      <div className="h-2 w-full bg-white/10 rounded"></div>
                      <div className="h-2 w-1/2 bg-white/10 rounded"></div>
                    </div>
                  </div>
                </div>
                <h3 className="text-2xl font-semibold mb-2 font-geist">Ready for buyers</h3>
                <p className="text-neutral-400 font-geist">
                  Automatically generate industry-standard pitch decks that highlight your project's strengths.
                </p>
              </div>

              {/* Feature 3: Recommendations */}
              <div className="bg-white/5 border border-white/10 rounded-[28px] p-8 backdrop-blur-sm hover:bg-white/10 transition-colors">
                <div className="h-48 rounded-xl bg-gradient-to-br from-neutral-800 to-neutral-900 border border-white/10 mb-6 flex items-center justify-center relative overflow-hidden">
                  <div className="flex flex-col gap-3 w-2/3">
                    <div className="flex items-center gap-3 p-3 bg-green-500/20 border border-green-500/30 rounded-lg">
                      <div className="w-5 h-5 rounded-full bg-green-500/50 flex items-center justify-center text-xs">✓</div>
                      <div className="h-1.5 w-2/3 bg-green-200/50 rounded"></div>
                    </div>
                    <div className="flex items-center gap-3 p-3 bg-white/5 border border-white/10 rounded-lg opacity-50">
                      <div className="w-5 h-5 rounded-full border border-white/30"></div>
                      <div className="h-1.5 w-1/2 bg-white/20 rounded"></div>
                    </div>
                  </div>
                </div>
                <h3 className="text-2xl font-semibold mb-2 font-geist">Actionable guidance</h3>
                <p className="text-neutral-400 font-geist">
                  Receive specific feedback on how to improve your script and increase its marketability.
                </p>
              </div>

              {/* Feature 4: Brand Fit */}
              <div className="bg-white/5 border border-white/10 rounded-[28px] p-8 backdrop-blur-sm hover:bg-white/10 transition-colors">
                <div className="h-48 rounded-xl bg-gradient-to-br from-neutral-800 to-neutral-900 border border-white/10 mb-6 flex items-center justify-center relative overflow-hidden">
                  <div className="grid grid-cols-2 gap-4 w-2/3">
                    <div className="aspect-video bg-orange-500/20 rounded-lg border border-orange-500/30"></div>
                    <div className="aspect-video bg-red-500/20 rounded-lg border border-red-500/30"></div>
                    <div className="aspect-video bg-amber-500/20 rounded-lg border border-amber-500/30"></div>
                    <div className="aspect-video bg-white/5 rounded-lg border border-white/10"></div>
                  </div>
                </div>
                <h3 className="text-2xl font-semibold mb-2 font-geist">Commercial options</h3>
                <p className="text-neutral-400 font-geist">
                  Visualize which brands and production houses align best with your creative vision.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Social Proof Section */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              {/* Stats */}
              <div>
                <h2 className="text-3xl font-semibold font-geist mb-6">Built for the modern creator economy.</h2>
                <div className="space-y-8">
                  <div className="flex items-end gap-3 pb-6 border-b border-neutral-100">
                    <span className="text-5xl font-bold text-neutral-900 font-geist">250+</span>
                    <span className="text-lg text-neutral-500 font-geist mb-1.5">projects analyzed</span>
                  </div>

                  {/* Testimonial */}
                  <div className="bg-neutral-50 p-6 rounded-2xl border border-neutral-100">
                    <div className="flex gap-1 mb-3 text-orange-400">
                      {[1, 2, 3, 4, 5].map((_, i) => (
                        <svg key={i} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                      ))}
                    </div>
                    <p className="text-neutral-700 italic font-geist mb-4">
                      "Artie helped me understand exactly where my script fit in the market. Two weeks later, I had a meeting with a producer."
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-neutral-200 rounded-full overflow-hidden">
                        <svg className="w-full h-full text-neutral-400" fill="currentColor" viewBox="0 0 24 24"><path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path></svg>
                      </div>
                      <div>
                        <p className="text-sm font-semibold font-geist">Sarah Jenkins</p>
                        <p className="text-xs text-neutral-500 font-geist">Screenwriter & Creator</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Marquee / Ticker */}
              <div className="relative overflow-hidden h-[400px] bg-neutral-900 rounded-[32px] p-8 shadow-xl">
                <div className="absolute inset-0 bg-gradient-to-b from-neutral-900 via-transparent to-neutral-900 z-10 pointer-events-none"></div>
                <div className="animate-marquee-vertical space-y-4">
                  {/* Cards repeating */}
                  {[...Array(2)].map((_, i) => (
                    <div key={i} className="space-y-4">
                      {/* Card 1 */}
                      <div className="bg-neutral-800/50 backdrop-blur border border-white/5 p-4 rounded-xl flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 bg-orange-500/20 text-orange-400 rounded-lg flex items-center justify-center font-bold">S</div>
                          <div>
                            <p className="text-white text-sm font-medium">Sci-Fi Pilot</p>
                            <p className="text-neutral-400 text-xs">Score: 88/100</p>
                          </div>
                        </div>
                        <span className="text-xs text-green-400 bg-green-500/10 px-2 py-1 rounded">High Demand</span>
                      </div>
                      {/* Card 2 */}
                      <div className="bg-neutral-800/50 backdrop-blur border border-white/5 p-4 rounded-xl flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 bg-amber-500/20 text-amber-400 rounded-lg flex items-center justify-center font-bold">D</div>
                          <div>
                            <p className="text-white text-sm font-medium">Documentary Series</p>
                            <p className="text-neutral-400 text-xs">Score: 92/100</p>
                          </div>
                        </div>
                        <span className="text-xs text-amber-400 bg-amber-500/10 px-2 py-1 rounded">Trending</span>
                      </div>
                      {/* Card 3 */}
                      <div className="bg-neutral-800/50 backdrop-blur border border-white/5 p-4 rounded-xl flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 bg-red-500/20 text-red-400 rounded-lg flex items-center justify-center font-bold">C</div>
                          <div>
                            <p className="text-white text-sm font-medium">Indie Comedy</p>
                            <p className="text-neutral-400 text-xs">Score: 79/100</p>
                          </div>
                        </div>
                        <span className="text-xs text-red-400 bg-red-500/10 px-2 py-1 rounded">Niche Match</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Final CTA Section */}
        <section className="py-32 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tighter text-neutral-900 font-geist mb-8">
              Ready to see what you're worth?
            </h2>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link to="/signup" className="inline-flex items-center justify-center h-14 px-8 text-lg font-medium text-white transition-colors bg-neutral-900 rounded-full hover:bg-neutral-800 font-geist shadow-xl w-full sm:w-auto">
                Start Free
                <ArrowRight className="h-5 w-5 ml-2" />
              </Link>
            </div>
            <p className="mt-6 text-sm text-neutral-500 font-geist">Join the waitlist. No credit card required.</p>
          </div>
        </section>

        {/* Mobile Sticky CTA Bar */}
        <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-neutral-200 p-4 z-40 flex items-center justify-between shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
          <div>
            <p className="text-xs font-semibold text-neutral-900 font-geist">Artie</p>
            <p className="text-[10px] text-neutral-500 font-geist">Know your worth</p>
          </div>
          <Link to="/signup" className="inline-flex items-center justify-center h-10 px-5 text-sm font-medium text-white bg-neutral-900 rounded-full font-geist">Get Started</Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-neutral-200 bg-white pb-24 md:pb-12 pt-16" id="buyers">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-12">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 bg-neutral-900 rounded-lg flex items-center justify-center text-white font-bold font-geist text-xl">A</div>
              <span className="text-xl font-bold tracking-tight text-neutral-900 font-geist">Artie</span>
            </Link>

            {/* Special Link */}
            <a href="#" className="group inline-flex items-center gap-2 text-neutral-900 font-medium font-geist hover:text-neutral-600 transition-colors">
              For Producers & Brands
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
          </div>

          <div className="flex flex-col md:flex-row justify-between gap-8 md:gap-12 mb-12 border-b border-neutral-100 pb-12">
            {/* Left Group: Product & Legal */}
            <div className="grid grid-cols-2 gap-8 md:gap-16">
              <div>
                <h4 className="font-semibold text-neutral-900 mb-4 font-geist">Product</h4>
                <ul className="space-y-3 text-sm text-neutral-600 font-geist">
                  <li><a href="#" className="hover:text-neutral-900">Scoring</a></li>
                  <li><a href="#" className="hover:text-neutral-900">Pitch Decks</a></li>
                  <li><a href="#" className="hover:text-neutral-900">Market Data</a></li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold text-neutral-900 mb-4 font-geist">Legal</h4>
                <ul className="space-y-3 text-sm text-neutral-600 font-geist">
                  <li><a href="#" className="hover:text-neutral-900">Privacy</a></li>
                  <li><a href="#" className="hover:text-neutral-900">Terms</a></li>
                </ul>
              </div>
            </div>

            {/* Right Group: Company & Social */}
            <div className="grid grid-cols-2 gap-8 md:gap-16">
              <div>
                <h4 className="font-semibold text-neutral-900 mb-4 font-geist">Company</h4>
                <ul className="space-y-3 text-sm text-neutral-600 font-geist">
                  <li><a href="#" className="hover:text-neutral-900">About</a></li>
                  <li><a href="#" className="hover:text-neutral-900">Careers</a></li>
                  <li><a href="#" className="hover:text-neutral-900">Contact</a></li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold text-neutral-900 mb-4 font-geist">Social</h4>
                <div className="flex gap-4">
                  <a href="#" className="text-neutral-400 hover:text-neutral-900 transition-colors">
                    <Twitter className="h-5 w-5" />
                  </a>
                  <a href="#" className="text-neutral-400 hover:text-neutral-900 transition-colors">
                    <Instagram className="h-5 w-5" />
                  </a>
                  <a href="#" className="text-neutral-400 hover:text-neutral-900 transition-colors">
                    <Linkedin className="h-5 w-5" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-neutral-500 font-geist">
            <p>© 2025 Artie. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;